import React, { useRef } from "react";
import SideBar from "src/layouts/components/sidebars";
import ProjectManagerHeader from "./components/projectManagerHeaders";

export const WithProjectManagerSideBar = (props) => {

  /** Variable declarations ------------------------------ **/
  const ref = useRef();

  return (
    <>
      <div
        className="d-flex"
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: "#f2f4f8",
        }}
      >
        <div
          style={{ width: "100%" }}
        >
          <ProjectManagerHeader />
          <div className="d-flex flex-row" style={{ backgroundColor: "white" }}>
            <SideBar ref={ref} />
            {props.children}
          </div>
        </div>

      </div>
    </>
  );
};
